<div class="feedback-page">
  <!-- Order header -->
  <div class="order-header">
    <div class="title-group">
      <button class="back-btn" (click)="navigateBack()" aria-label="Back to orders">‹</button>
      <div class="order-identity">
        <div class="order-number">#{{ orderReference }}</div>
        <div class="order-subtitle">Order details</div>
      </div>
    </div>
  </div>

  <!-- Order summary -->
  @if (order) {
    <div class="order-summary">
      <div class="table-and-customer">
        <span class="table-badge">{{ tableLabel }}</span>
        <span class="customer-name">{{ customerName }}</span>
      </div>
      <span class="placed-at">{{ formatOrderPlaced() }}</span>
    </div>
  }

  <!-- Feedback -->
  <div class="feedback-section">
    <div class="feedback-heading">
      <h2 class="section-title">Feedback</h2>
      <!-- Stated, not implied: this is all a restaurant can do here. Guest
           feedback is private and carries no reply or report action. -->
      <span class="read-only-badge">Read only</span>
    </div>

    <div class="average-card">
      <div class="rating-value">
        <div class="rating-label">Average rating</div>
        <div class="score-row">
          <!-- An em dash, not 0.0 — nobody rated this order badly, nobody
               rated it at all. -->
          <span class="score">{{
            averageRating === null ? '—' : (averageRating | number: '1.1-1')
          }}</span>
          <span class="score-stars" [class.muted]="averageRating === null">
            {{ averageRating === null ? '☆ ☆ ☆ ☆ ☆' : stars(averageRating) }}
          </span>
        </div>
      </div>
      <div class="rating-count">
        {{
          entryCount === 0
            ? 'No ratings'
            : entryCount + (entryCount === 1 ? ' review' : ' reviews') + ' from this table'
        }}
      </div>
    </div>

    @if (hasEntries) {
      <div class="feedback-list">
        @for (entry of entries; track entry.created_at + entry.review) {
          <div class="feedback-card">
            <div class="review-metadata">
              <div class="guest-and-rating">
                @if (entry.guest_name) {
                  <div class="guest-badge">
                    <span class="initials">{{ initials(entry) }}</span>
                    <span class="guest-name">{{ entry.guest_name }}</span>
                  </div>
                }
                <span class="entry-stars">{{ stars(entry.rating) }}</span>
              </div>
              <span class="entry-date">{{ formatDateTime(entry.created_at) }}</span>
            </div>
            <p class="entry-text">{{ entry.review }}</p>
          </div>
        }
      </div>
    } @else if (loadFailed) {
      <div class="no-feedback">
        <div class="icon-background">!</div>
        <div class="empty-title">Failed to load feedback</div>
        <div class="empty-body">Something went wrong. Please try again.</div>
      </div>
    } @else if (feedback) {
      <div class="no-feedback">
        <div class="icon-background">💬</div>
        <div class="empty-title">No feedback yet</div>
        <div class="empty-body">
          Feedback from this order will appear here when guests at this table submit their reviews.
        </div>
      </div>
    }
  </div>
</div>
